import Vue from 'vue';
import App from './App.vue';
import "@fortawesome/fontawesome-free/css/all.css";
import router from './router';
import "./templates";
import http from "./http";
import accountsHttp from "./http/accountsHttp";
import imaginHttp from "./http/imagingHttp";
import { store } from "./store";
import { HMIS_USERNAME } from "@/plugins/vars";
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import 'allsettled-polyfill';

window.moment = require('moment');
window.Cookies = require('js-cookie');
window.Swal = require('sweetalert2').mixin({
    toast: false,
    position: 'top',
    showConfirmButton: true,
});

Vue.filter('dateFormat', function (value) {
  if (!value) return '-';

  return window.moment(value).format('DD MMMM, YYYY');
});

Vue.filter('numberOfYears', function (value) {
  if (!value) return '-';

  return window.moment().diff(value, 'years');
});

Vue.filter('dateFormatDT', function (value) {
  if (!value) return '';

  return window.moment(value).format('DD MMMM, YYYY - HH:mm A');
});

Vue.filter('numberFormat', function (value) {
  if (!value) return '0.00';

  return parseFloat(value).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
});

Vue.config.productionTip = false;
Vue.prototype.$http = http;
Vue.prototype.$accountsHttp = accountsHttp;
Vue.prototype.$imagingHttp = imaginHttp;
Vue.prototype.$moment = window.moment;
Vue.prototype.$formatCurrency = function (value) {
  if (!value) return '0.00';

  return parseFloat(value).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
// 2. Intercept the route click here
router.beforeEach((to, from, next) => {
  if (to.meta.runMethod) {
    this.RecordUserAccessActivity('evans','checki');
  }
  next(); // Allows navigation to complete
});

Vue.component('v-select', vSelect);

new Vue({
  store,

  data: {

    loading: false,
    pendingLabQueue: 0,
    pendingRadiologyQueue: 0,
    username: window.Cookies.get(HMIS_USERNAME),
    companydetails:JSON.parse(localStorage.getItem('P_103')), 
    companyconfigs:JSON.parse(localStorage.getItem('P_104')),
   // companyconfigsprintprescriptionstamp:JSON.parse(localStorage.getItem('P_104')),
   
  //  companyconfigsprintprescriptionstamp:JSON.parse(localStorage.getItem('P_104'))[5].valueBit?JSON.parse(localStorage.getItem('P_104'))[5].valueBit:false,
   // companyconfigsprintinvoicestamp:JSON.parse(localStorage.getItem('P_104'))[4].valueBit?JSON.parse(localStorage.getItem('P_104'))[4].valueBit:false,
    //companyconfigsprintadmissiononinvoice:JSON.parse(localStorage.getItem('P_104'))[3].valueBit?JSON.parse(localStorage.getItem('P_104'))[3].valueBit:false,
   // companyconfigsprintdateoninvoice:JSON.parse(localStorage.getItem('P_104'))[2].valueBit?JSON.parse(localStorage.getItem('P_104'))[2].valueBit:false,
    //companyconfigsdocumentvisitupload:JSON.parse(localStorage.getItem('P_104'))[0].valueBit?JSON.parse(localStorage.getItem('P_104'))[0].valueBit:false,

     companyconfigsprintprescriptionstamp:false,
     companyconfigsprintinvoicestamp:false,
     companyconfigsprintadmissiononinvoice:false,
     companyconfigsprintdateoninvoice:false,
     companyconfigsdocumentvisitupload:false,
  },
  computed: {

       
    minFilterDate(){
       // const today = new Date();
        var today = new Date();
        today.setDate(today.getDate() - 2);
      return today.toISOString().split('T')[0]; // Returns "2024-05-20" format
    
    },
    // maskedPhone(rawPhoneNumber) {
    //   if (!rawPhoneNumber) return "";
    //   if (rawPhoneNumber.length<5) return rawPhoneNumber;
    //   else
    //   // Slice removes the last 3 characters and replaces them with asterisks
    //   return rawPhoneNumber.slice(0, -3) + "***";
    // }
  },
  methods: {

    formatDate(date) {

      return window.moment(date).format('YYYY-MM-DD');
    },

    formatFloat(num) {
      if(!num) return 0;
  
      return parseFloat(num);
    },

    formatLowercase(text) {
      if(!text) return ``;

      return text.toLowerCase(text)
    },
    maskedPhone(rawPhoneNumber) {
      if (!rawPhoneNumber) return "";
      if (rawPhoneNumber.length<5) 
      {return rawPhoneNumber;}
      else
     { // Slice removes the last 3 characters and replaces them with asterisks
      return rawPhoneNumber.slice(0, -3) + "***";}
    }, 
    checkAuth(pageName) {
      const rights = JSON.parse(window.localStorage.getItem('P_102'));

      const check = rights.filter(right => right.name == pageName);

      return check.length ? true : false;
    },
   

    exportToExcel(filename = '', tableID) {
      var downloadurl;
      var dataFileType = 'application/vnd.ms-excel';
      var tableSelect = document.getElementById(tableID);
      var tableHTMLData = tableSelect.outerHTML.replace(/ /g, '%20');

      // Specify file name
      filename = filename?filename+'.xlsx':'export_excel_data.xlsx';

      // Create download link element
      downloadurl = document.createElement("a");

      document.body.appendChild(downloadurl);

      if(navigator.msSaveOrOpenBlob){
          var blob = new Blob(['\ufeff', tableHTMLData], {
              type: dataFileType
          });
          navigator.msSaveOrOpenBlob( blob, filename);
      } else {
          // Create a link to the file
          downloadurl.href = 'data:' + dataFileType + ', ' + tableHTMLData;

          // Setting the file name
          downloadurl.download = filename;

          //triggering the function
          downloadurl.click();
      }
    },
    RecordUserAccessActivity(username,pageName) {
      var userActivity= 'Page Access: Successfully acccessed ' +pageName;
      var userActivityModels={
        userActivity:userActivity,
        userHostAddress:window.location.host,
        userHostName:window.location.hostname,
         userName:username,
      }
         this.$root.loading = true;
         this.$http.post(`Admin/RecordUserActivity`, userActivityModels).then(response => {
              
           this.responsemsg= response.data;
             this.$root.loading = false;
          }).catch(() => { this.$root.loading = false; });
},
    RecordUserActivity(username,userActivity) {
      var userActivityModels={
        userActivity:userActivity,
        userHostAddress:window.location.host,
        userHostName:window.location.hostname,
         userName:username,
      }
      // this.userActivityModels.userActivity="User Login: "+username+": Successfully Logged In";
      // this.userActivityModels.userHostAddress=window.location.host;
      // this.userActivityModels.userHostAddress=window.location.hostname;
      // this.userActivityModels.userName=username;
      
      this.$root.loading = true;
            this.$http.post(`Admin/RecordUserActivity`, userActivityModels).then(response => {
                 
              this.responsemsg= response.data;
                this.$root.loading = false;
             }).catch(() => { this.$root.loading = false; });

      
    },
  },

  
  router,
  render: h => h(App),
}).$mount('#app');
